module.exports = __webpack_public_path__ + "img/photo-example.370c97c6.jpg";